<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Eliminar Registro
      </v-card-title>
      <v-card-text>
        ¿Seguro que desea eliminar este registro?<br />
        <b>{{ namex }}</b><br />
        Esta acción no se puede deshacer
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="OnConfirmDelete"
        >
          Eliminar
        </v-btn>
        <v-btn
          color="secondary"
          @click="isDialogVisible = false"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref } from '@vue/composition-api'

export default {
  props: {
    // event: {
    //   type: Object,
    //   required: true,
    // },
  },
  setup(props, { emit }) {
    const isDialogVisible = ref(false)
    const namex = ref('')
    const keyx = ref('')
    const ShowDeleteDialog = (key, name) => {
      isDialogVisible.value = true
      namex.value = name
      keyx.value = key
    }
    const OnConfirmDelete = () => {
      isDialogVisible.value = false
      emit('confirm-delete', keyx.value)
    }

    return {
      isDialogVisible,
      namex,
      keyx,
      OnConfirmDelete,
      ShowDeleteDialog,
    }
  },
}
</script>
